__turbopack_context__.v({
  "antena": "C0HU5G_antena",
  "antenaLeft": "C0HU5G_antenaLeft",
  "antenaRight": "C0HU5G_antenaRight",
  "antenaTip": "C0HU5G_antenaTip",
  "astronaut": "C0HU5G_astronaut",
  "astronautAntena": "C0HU5G_astronautAntena",
  "astronautBackpack": "C0HU5G_astronautBackpack",
  "astronautBody": "C0HU5G_astronautBody",
  "astronautGlass": "C0HU5G_astronautGlass",
  "astronautHand": "C0HU5G_astronautHand",
  "astronautHands": "C0HU5G_astronautHands",
  "astronautHelmet": "C0HU5G_astronautHelmet",
  "astronautWire": "C0HU5G_astronautWire",
  "blink": "C0HU5G_blink",
  "center": "C0HU5G_center",
  "circle": "C0HU5G_circle",
  "circleInner": "C0HU5G_circleInner",
  "circleMain": "C0HU5G_circleMain",
  "circleOuter": "C0HU5G_circleOuter",
  "crater": "C0HU5G_crater",
  "crater1": "C0HU5G_crater1",
  "crater2": "C0HU5G_crater2",
  "crater3": "C0HU5G_crater3",
  "crater4": "C0HU5G_crater4",
  "crater5": "C0HU5G_crater5",
  "crater6": "C0HU5G_crater6",
  "craters": "C0HU5G_craters",
  "earDown": "C0HU5G_earDown",
  "earUp": "C0HU5G_earUp",
  "floating": "C0HU5G_floating",
  "four": "C0HU5G_four",
  "four1": "C0HU5G_four1",
  "four2": "C0HU5G_four2",
  "glow": "C0HU5G_glow",
  "glow1": "C0HU5G_glow1",
  "glow2": "C0HU5G_glow2",
  "handLeft": "C0HU5G_handLeft",
  "handRight": "C0HU5G_handRight",
  "main": "C0HU5G_main",
  "oh": "C0HU5G_oh",
  "planet": "C0HU5G_planet",
  "sorry": "C0HU5G_sorry",
  "star": "C0HU5G_star",
  "stars": "C0HU5G_stars",
  "wrench": "C0HU5G_wrench",
});
